import * as ol from '../../services/memberManagement';

export default {
  namespace: 'ol',

  state: {
    logList: null,
  },

  effects: {
    //等级变化
    *getLog({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(ol.getLog, values);
      yield put({
        type: 'save',
        payload: {
          logList: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
